import React from 'react'
import QuestionTpl from '../templates/QuestionTpl'
import { NumberInput } from './NumberInput'

const min = 10000
const max = 150000
const step = 1000

export default class BudgetQn extends React.Component {

    static id = 'budget'
    static defaultValue = '20000'

    render() {
        const { id, value, onChange } = this.props;
        return (
            <QuestionTpl
                {...this.props}
                title="Budget"
                description="The value of the car"
                fineprint="What is the cost of the car you would like to lease?"
                component={NumberInput}
                componentProps={{
                    value,
                    onChange: (e) => onChange(id, e.target.value),
                    min,
                    max,
                    step
                }}
            />
        );
    }
}
